import { useEffect, useState } from "react";
import { Cell, Label, Pie, PieChart, PieLabelRenderProps, ResponsiveContainer, Tooltip } from "recharts"
import { Chart } from "react-google-charts";
import { shelves } from "../../assets/data/constants";
import { useNavigate } from "react-router-dom";

interface AuthorsPieChartProps {
    library: any[]; 
}

const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff7f50', '#00C49F', '#FFBB28', '#FF8042'];

const options = {
    colors: COLORS,
    legend: {
        position: "bottom",
    },
    chartArea: {
        top: 20,
        width: '100%', // vergroot dit voor een grotere pie
        height: '80%'
    },
};


const AuthorsPieChart: React.FC<AuthorsPieChartProps> = ({library}) => {
    const [formattedData, setFormattedData] = useState<any[]>([]);
    const navigate = useNavigate();

    const formatData = () => {
        const shelfCounts: Record<string, number> = library.reduce((acc, book) => {
            const shelf = book["Author"] || "unknown"; // fallback als null
            acc[shelf] = (acc[shelf] || 0) + 1;
            return acc;
        }, {} as Record<string, number>);

        const result: [string, number][] = Object.entries(shelfCounts).map(
            ([name, value]) => [name, value]
        );

        // sort on count
        result.sort((a, b) => b[1] - a[1]);

        // top 5 authors and add other with count
        const topAuthors = result.slice(0, 5);
        const otherCount = result.slice(5).reduce((acc, [name, count]) => acc + count, 0);
        topAuthors.unshift(["Other", otherCount]);

        // Add column headers
        const finalData: (string | number)[][] = [["Author", "Count"], ...topAuthors];

        setFormattedData(finalData);
    };

    useEffect(() => {
        formatData();
    }, [library]);

    if (library.length <= 0) {
        // loader
        return (
             <div className="bg-white rounded-3xl shadow-lg p-4 min-h-64 h-full mt-[40px] mb-[40px]">
                <div className="loader"></div> 
            </div>
        )
    }


      
    return(
        <div className="bg-white rounded-3xl shadow-lg p-4 min-h-64 h-full">
            <h1 className="text-2xl font-bold  text-[#60637A]">
                    Top 5 Authors in library
            </h1>
            <div  style={{ width: '100%', height: '300px', cursor: 'pointer' }} >
                <Chart
                    chartType="PieChart"
                    data={formattedData}
                    options={options}
                    width={"100%"}
                    height={"100%"}
                    chartEvents={[
                        {
                        eventName: "select",
                        callback: ({ chartWrapper }) => {
                            const chart = chartWrapper?.getChart();
                            const selection = chart?.getSelection();

                            if (selection?.length === 0) return;

                            const selectedItem = selection?.[0];
                            const rowIndex = selectedItem?.row;

                            if (rowIndex !== null) {
                            const label = formattedData[rowIndex + 1][0]; // +1 vanwege headers
                            if (label === "Other") return;
                            navigate('/stats/details?value=' + label + '&type=authors-library');
                            }
                        },
                        },
                    ]}
                />
            </div>
        </div>
    )
    
}

export default AuthorsPieChart